export default __webpack_public_path__ + "static/media/group-therapy.301efa5b.jpg";